import { render, staticRenderFns } from "./Padlocks.vue?vue&type=template&id=3071acd2&"
import script from "./Padlocks.vue?vue&type=script&lang=js&"
export * from "./Padlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports